import { FC, RefObject } from 'react';

import { useOutsideAlerter } from '../../utils/hooks';
import { DesktopSubmenu, MobileSubmenu, useHeaderNavigation } from '../MegaMenu';

export interface SubmenuComponentProps {
  headerRef: RefObject<HTMLHeadingElement | null>;
}

export const SubmenuComponent: FC<SubmenuComponentProps> = ({ headerRef }) => {
  const { closeMenu } = useHeaderNavigation();

  useOutsideAlerter(headerRef, closeMenu);

  return (
    <>
      <MobileSubmenu />
      <DesktopSubmenu />
    </>
  );
};
